import { useContext } from "react";

import { IConfig } from "./settingsTypes";
import { SettingsContext } from "./context";

export const useConfig = (): IConfig => {

    const context = useContext(SettingsContext);
    if (!context)
        throw new Error("SettingsContext not found");

    return context.config;
};